'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { PrV2ViewedCheckboxIndicator } from './pr-v2-viewed-checkbox-indicator';
import { BetterTooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
export function PrV2GroupNavigation(t0) {
  const $ = _c(15);
  const {
    onNavigatePrevious,
    onNavigateNext,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-flex shrink-0 items-center gap-0.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !onNavigatePrevious;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronLeft className="size-3.5" aria-hidden="true" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onNavigatePrevious || $[4] !== t2) {
    t4 = <BetterTooltip content="Previous group"><button type="button" aria-label="Go to previous group" disabled={t2} onClick={onNavigatePrevious} className="inline-flex size-6 items-center justify-center rounded-sm text-zinc-500 hover:bg-zinc-900 hover:text-zinc-200 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-zinc-600 disabled:pointer-events-none disabled:opacity-30">{t3}</button></BetterTooltip>;
    $[3] = onNavigatePrevious;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !onNavigateNext;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronRight className="size-3.5" aria-hidden="true" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== onNavigateNext || $[8] !== t5) {
    t7 = <BetterTooltip content="Next group"><button type="button" aria-label="Go to next group" disabled={t5} onClick={onNavigateNext} className="inline-flex size-6 items-center justify-center rounded-sm text-zinc-500 hover:bg-zinc-900 hover:text-zinc-200 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-zinc-600 disabled:pointer-events-none disabled:opacity-30">{t6}</button></BetterTooltip>;
    $[7] = onNavigateNext;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== children || $[11] !== t1 || $[12] !== t4 || $[13] !== t7) {
    t8 = <div className={t1} aria-label="Group navigation">{t4}{children}{t7}</div>;
    $[10] = children;
    $[11] = t1;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
export function PrV2GroupReviewedControl(t0) {
  const $ = _c(9);
  const {
    sectionIndex,
    groupName,
    isGroupReviewed,
    onToggleGroupReviewed
  } = t0;
  if (!onToggleGroupReviewed) {
    return null;
  }
  const t1 = isGroupReviewed ? `Mark ${groupName} as unviewed` : `Mark ${groupName} as viewed`;
  const t2 = `pr-v2-group-reviewed-${sectionIndex}`;
  let t3;
  if ($[0] !== isGroupReviewed) {
    t3 = <PrV2ViewedCheckboxIndicator isViewed={isGroupReviewed} />;
    $[0] = isGroupReviewed;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span>Viewed</span>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isGroupReviewed || $[4] !== onToggleGroupReviewed || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t5 = <button type="button" aria-pressed={isGroupReviewed} aria-label={t1} data-testid={t2} onClick={onToggleGroupReviewed} className="inline-flex h-6 shrink-0 items-center gap-1.5 rounded-sm px-1 text-zinc-500 hover:text-zinc-300 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-zinc-600">{t3}{t4}</button>;
    $[3] = isGroupReviewed;
    $[4] = onToggleGroupReviewed;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}